<!-- epigrafe -->
<div class="divEpigrafe" *ngIf="exibirEpigrafe"
        [class]="epigrafeSelecionada? 'epigrafe-selecionada' : 'epigrafe-nao-selecionada'"
        [style]="epigrafeSelecionavel? 'cursor: pointer;':''"
        (click)="clickNaEpigrafe()">
    <div class="epigrafe">{{ visaoAto.epigrafeCompleta }}</div>
    <ng-container *ngFor="let ancoraRetificacao of visaoAto.ancorasRetificacaoEpigrafe">
        <div class="aviso-retificacao">
            {{ ancoraRetificacao.texto }}
            <ng-container *ngTemplateOutlet="templateExcluirAnotacao; context:{ancora:ancoraRetificacao}"></ng-container>
        </div>
    </ng-container>
    <div class="dataPublicacao">{{ visaoAto.dadosPublicacao }}</div>
</div>

<!-- anotações no ato -->
<div class="area-anotacoes-ato">
    <ng-container *ngIf="ancoraRepublicacao || visaoAto.ancorasNoAto.length > 0">
        <div class="ancoras-ato" *ngIf="ancoraRepublicacao">
            <a class="ancora" [routerLink]="getUrl(ancoraRepublicacao)" [title]="getTitle(ancoraRepublicacao)">{{ ancoraRepublicacao.texto }}</a>
        </div>

        <div class="ancoras-ato" *ngFor="let a of visaoAto.ancorasNoAto">
            <ng-container *ngTemplateOutlet="templateAnotacaoPassiva; context:{ancora:a}"></ng-container>
            <a class="ancora" [routerLink]="getUrl(a)" [fragment]="getFragmento(a)" [title]="getTitle(a)" (click)="clickAnotacao.emit({ancora: a, ehPassiva: true})">
                <span>{{ a.ehAgendamento ? a.textoAgendamento : a.texto }}</span>
            </a>
            <ng-container *ngTemplateOutlet="templateExcluirAnotacao; context:{ancora:a}"></ng-container>
            <ng-container *ngTemplateOutlet="templateDataInicio; context:{ancora:a, ehAnotacaoPassiva:true}"></ng-container>
        </div>
    </ng-container>
</div>

<div class="area-ementa-ato">
    <div class="caixinha-ementa">
        <!-- mensagens ato republicado ou republicador -->
        <div class="mensagem-republicacao-ato" *ngIf="visaoAto.ehRepublicado">
            <!-- <div class="mensagem-republicacao-ato"> -->
              Este ato foi republicado. Para visualizar o texto que sucedeu a este, acesse o link acima ou, na
              ausência de link, refaça sua pesquisa no sistema Normas.
        </div>
        <div class="mensagem-visao-exclusiva" *ngIf="visaoAto.ehVisaoExclusiva">
            Apenas o texto original deste ato pode ser consultado. Não é possível garantir que todas as informações
            sobre eventuais alterações ou revogações estejam disponíveis.
        </div>

        <!-- ementas -->
        <ng-container *ngFor="let s of visaoAto.ementas">
            <ng-container *ngTemplateOutlet="templateSegmento; context:{segmento: s}"></ng-container>
        </ng-container>
    </div>
</div>

<div style="clear: both"></div>

<!-- histórico -->
<div class="historico" *ngIf="visaoAto.historico.length > 0">
    <div class="expansor">
        Histórico de alterações
        <i *ngIf="expandirHistorico" class="material-icons icon-24 inativo nao-imprimivel" title="retrair" (click)="expandirHistorico = false">expand_less</i>
        <i *ngIf="!expandirHistorico"  class="material-icons icon-24 ativo nao-imprimivel" title="expandir" (click)="expandirHistorico = true">expand_more</i>
    </div>
    <ng-container *ngIf="expandirHistorico">
        <div *ngFor="let a of visaoAto.historico">
            <a class="ancora" [routerLink]="getUrl(a)" [title]="getTitle(a)" (click)="clickAnotacao.emit({ancora: a, ehPassiva: true})">
                {{ a.texto }}
            </a>
        </div>
    </ng-container>
</div>

<!-- segmentos -->
<ng-container *ngIf="!(!visaoAto.vigente && visaoSelecionada.isVigente())">
    <ng-container *ngFor="let s of visaoAto.outrosSegmentos">
        <ng-container *ngTemplateOutlet="templateSegmento; context:{segmento: s}"></ng-container>
    </ng-container>
</ng-container>

<!-- Espaçamento para exibir o segmento selecionado pelo link no topo da página-->
<ng-container *ngIf="exibirEspacamento">
<div id="espacamento-{{visaoAto.idAto}}"></div>
</ng-container>

<ng-template #templateSegmento let-segmento="segmento">
    <ng-container>
        <div class="segmento" [id]="segmento.idSegmento" [style]="segmento.style" *ngIf="!segmento.omitir || segmento.ancorasOrigem.length > 0 || segmento.ancorasDestino.length > 0">

            <!-- numerador de seleção -->
            <div class="indice-selecao" *ngIf="obterIndiceSegmentoSelecionado(segmento) >= 0 && !segmento.omitir">{{ obterIndiceSegmentoSelecionado(segmento) + 1 }}</div>

            <!-- textoIntegra -->
            <span [innerHTML]="getInnerHTML(segmento)" class="conteudo-segmento-ato" [class]="getClass(segmento)" (click)="clickNoSegmento(segmento)"
                *ngIf="(segmento.idTipoSegmento !== 16 || !segmento.arquivoBinario) && !segmento.omitir"></span>

            <!-- anexos em anotação -->
            <ng-container *ngIf="segmento.arquivoBinario && visaoSelecionada.isAnotacao() && !segmento.omitir">
                <div [class]="getClass(segmento)" (click)="clickNoSegmento(segmento)">
                    <a>
                        <em class="material-icons icon-18">file_present</em> {{ segmento.arquivoBinario.nomeArquivoBinario }}
                    </a>
                    <div class="texto-anexo">::&nbsp; {{ segmento.textoIntegra }}</div>
                </div>
            </ng-container>

            <!-- anexos em visões -->
            <ng-container *ngIf="segmento.arquivoBinario && !visaoSelecionada.isAnotacao() && !segmento.omitir">
                <!-- arquivo comum -->
                <div class="anexo-ancora" *ngIf="[2,3,4,5].indexOf(segmento.arquivoBinario.idTipoArquivo) < 0" [class]="getClass(segmento)" >

                    <a (click)="baixarAnexo(segmento)" title="Baixar o arquivo" *ngIf="!visaoSelecionada.isAnotacao() && !isConsultaApp()">
                        <em class="material-icons icon-18">file_present</em> {{ segmento.arquivoBinario.nomeArquivoBinario }}
                    </a>
                    <a [href]="montarUrlAnexoNaConsultaApp(segmento)" title="Baixar o arquivo" *ngIf="!visaoSelecionada.isAnotacao() && isConsultaApp()">
                        <em class="material-icons icon-18">file_present</em> {{ segmento.arquivoBinario.nomeArquivoBinario }}
                    </a>

                    <a *ngIf="visaoSelecionada.isAnotacao()">
                        <em class="material-icons icon-18">file_present</em> {{ segmento.arquivoBinario.nomeArquivoBinario }}
                    </a>
                </div>
                <!-- html -->
                <div class="segmento envelope-tabela-anexa" [class]="getClass(segmento)" [innerHTML]="getInnerHtmlAnexo(segmento)" *ngIf="[4,5].indexOf(segmento.arquivoBinario.idTipoArquivo) >= 0"></div>
                <!-- imagem -->
                <div class="inner-imagem" *ngIf="[2,3].indexOf(segmento.arquivoBinario.idTipoArquivo) >= 0" [class]="getClass(segmento)" >
                    <img [src]="'data:image;base64,'+segmento.arquivoBinario.arquivoBinario" alt="imagem">
                </div>
            </ng-container>

            <!-- quebrar a linha pra exibir anotações na linha seguinte em segmentos centralizados-->
            <ng-container *ngIf="segmento.style && segmento.style['text-align'] === 'center'">
                <ng-container *ngIf="segmento.ancorasDestino.length > 0">
                    <br>
                </ng-container>
            </ng-container>

            <!-- anotações passivas no segmento -->
            <ng-container *ngFor="let a of segmento.ancorasDestino">
                &nbsp;&nbsp;
                <ng-container *ngTemplateOutlet="templateAnotacaoPassiva; context:{ancora:a}"></ng-container>
                <a class="ancora ancora-segmento" [routerLink]="getUrl(a)" [fragment]="getFragmento(a)" [title]="getTitle(a)" (click)="clickAnotacao.emit({ancora: a, ehPassiva: true})">
                    <span>{{ a.ehAgendamento ? a.textoAgendamento : a.texto }}</span>
                </a>
                <ng-container *ngTemplateOutlet="templateExcluirAnotacao; context:{ancora:a}"></ng-container>
                <ng-container *ngTemplateOutlet="templateDataInicio; context:{ancora:a, ehAnotacaoPassiva:true}"></ng-container>
            </ng-container>

            <!-- toogle anotações ativas -->
            <span class="toggle-anotacao-ativa" *ngIf="segmento.ancorasOrigem.length > 0" (click)="segmento.exibirAncorasOrigem = !segmento.exibirAncorasOrigem">
                &nbsp;&nbsp;<em class="material-icons icon-24">import_export</em>
            </span>
        </div>

        <!-- anotações ativas no segmento -->
        <ng-container *ngIf="segmento.exibirAncorasOrigem">
            <div class="anotacao-ativa" *ngFor="let a of segmento.ancorasOrigem">
                <ng-container *ngTemplateOutlet="templateAnotacaoAtivaOrigem; context:{ancora:a}"></ng-container>
                <a class="ancora" [routerLink]="getUrl(a)" [fragment]="getFragmento(a)" [title]="getTitle(a)" (click)="clickAnotacao.emit({ancora: a, ehPassiva: false})">
                    <span>{{ a.texto.split('|')[0] }}
                        <span>{{ a.texto.split('|')[1] }}</span>
                        {{ a.texto.split('|')[2] }}</span>
                </a>
                <ng-container *ngTemplateOutlet="templateExcluirAnotacao; context:{ancora:a}"></ng-container>
                <ng-container *ngTemplateOutlet="templateDataInicio; context:{ancora:a}"></ng-container>
            </div>
        </ng-container>
    </ng-container>
</ng-template>

<!-- template do ícone de exclusão de uma anotação -->
<ng-template #templateExcluirAnotacao let-ancora="ancora">
    <suite-rfb-confirmation-link *ngIf="ancora.permiteExcluir && visaoSelecionada.isAnotacao()" popupTitle="Desfazer anotação"
        question="Deseja desfazer esta anotação?" (accept)="clickExcluirAnotacao.emit(ancora.idAnotacao)">
        <em class="material-icons btn-excluir" title="Desfazer anotação">
            disabled_by_default
        </em>
    </suite-rfb-confirmation-link>
</ng-template>

<!-- template dos ícones de anotação passiva e agendamento-->
<ng-template #templateAnotacaoPassiva let-ancora="ancora">
    <ng-container *ngIf="ancora.ehAgendamento">
        <div class="icone-ancora-ativa" title="Anotação agendada"><em class="material-icons">import_export</em></div>
        <span class="icone-agendamento" title="Anotação agendada">
            <img src="/assets/imagens/icone-agendamento.png" alt="Agendamento de anotação">
        </span>
        &nbsp;
    </ng-container>
    <ng-container *ngIf="!ancora.ehAgendamento">
        <div class="icone-ancora-ativa azul" title="Anotação"><em class="material-icons">import_export</em></div>
    </ng-container>
</ng-template>

<!-- template dos ícones de anotação passiva e agendamento-->
<ng-template #templateAnotacaoAtivaOrigem let-ancora="ancora">
    <ng-container *ngIf="ancora.ehAgendamento">
        <div class="icone-ancora-ativa" title="Anotação agendada"><em class="material-icons">import_export</em></div>
        <span class="icone-agendamento" title="Anotação agendada">
            <img src="/assets/imagens/icone-agendamento.png" alt="Agendamento de anotação">
        </span>
        <span title="Data de início de vigência da anotação">
            &nbsp;
            <span class="texto-agendamento">({{ ancora.dataInicioVigencia }})</span>
        </span>
    </ng-container>
    <ng-container *ngIf="!ancora.ehAgendamento">
        <div class="icone-ancora-ativa azul" title="Anotação"><em class="material-icons">import_export</em></div>
    </ng-container>
</ng-template>

<!-- template do ícone que exibe a data de início de vigência da anotação e permite alterar -->
<ng-template #templateDataInicio let-ancora="ancora" let-ehAnotacaoPassiva="ehAnotacaoPassiva">
    <span class="info-data-inicio" *ngIf="ancora.permiteAlterarData && visaoSelecionada.isAnotacao()">
        <ng-container *ngIf="permiteAlterarDataVigenciaTodasAnotacoes">
            <!-- Permite alterar todas as anotação do segmento -->
            <em *ngIf="!ancora.dataInicioVigencia" class="material-icons btn-vermelho" title="Editar data inicial de vigência" (click)="clickDataInicioVigencia(ancora)">edit_calendar</em>
            <em *ngIf="ancora.dataInicioVigencia" class="material-icons btn-verde" title="Editar data inicial de vigência" (click)="clickDataInicioVigencia(ancora)">edit_calendar</em>
            <ng-container *ngIf="!ancora.ehAgendamento || (visaoSelecionada.isAnotacao() && ehAnotacaoPassiva)">
                <ng-container *ngIf="ancora.dataInicioVigencia">
                    <span (click)="clickDataInicioVigencia(ancora)">&nbsp;({{ ancora.dataInicioVigencia }})</span>
                </ng-container>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="!permiteAlterarDataVigenciaTodasAnotacoes">
            <!-- Permite alterar somente a última anotação do segmento -->
            <ng-container *ngIf="ancora.permiteExcluir">
                <em *ngIf="!ancora.dataInicioVigencia" class="material-icons btn-vermelho" title="Editar data inicial de vigência" (click)="clickDataInicioVigencia(ancora)">edit_calendar</em>
                <em *ngIf="ancora.dataInicioVigencia" class="material-icons btn-verde" title="Editar data inicial de vigência" (click)="clickDataInicioVigencia(ancora)">edit_calendar</em>
            </ng-container>
            <ng-container *ngIf="!ancora.ehAgendamento || (visaoSelecionada.isAnotacao() && ehAnotacaoPassiva)">
                <ng-container *ngIf="ancora.dataInicioVigencia">
                    <span *ngIf="ancora.permiteExcluir" (click)="clickDataInicioVigencia(ancora)">&nbsp;({{ ancora.dataInicioVigencia }})</span>
                    <span *ngIf="!ancora.permiteExcluir" style="cursor: default;">&nbsp;({{ ancora.dataInicioVigencia }})</span>
                </ng-container>
            </ng-container>
        </ng-container>
    </span>
    <ng-container *ngIf="!ancora.ehAgendamento && !(ancora.permiteAlterarData && visaoSelecionada.isAnotacao()) && ancora.exibirDataInicioVigencia">
        <ng-container *ngIf="ancora.dataInicioVigencia">
            <div class="inicio-vigencia" title="Data de início de vigência da anotação">
                <span class="material-icons date-range" (click)="ancora.exibirEssaDataInicioVigencia=!ancora.exibirEssaDataInicioVigencia">date_range</span>
                <ng-container *ngIf="exibirDatasVigencia || ancora.exibirEssaDataInicioVigencia">
                    <span class="texto">&nbsp;{{ ancora.dataInicioVigencia }}</span>
                </ng-container>
            </div>
        </ng-container>
    </ng-container>
</ng-template>

<!-- modal de alteração da data de início de vigência -->
<div class="area-morta-modal-parametros" *ngIf="ancoraEditandoDataInicioVigencia" (keyup)="$event.preventDefault()" role="dialog">
    <div class="modal-content">
        <h2>Alterar data de início de vigência da anotação</h2>

        <div class="row">
            <suite-rfb-date-picker name="dataInicioVigenciaVal" label="Nova data" [(ngModel)]="dataInicioVigenciaVal"
                [outsideClick]="true" [adaptivePosition]="true"></suite-rfb-date-picker>
        </div>
        <div *ngIf="!verificarDataInicioVigenciaVal()" class="mensagem-agendamento-nao-habilitado">Este tipo de anotação não permite agendamento</div>
        <div *ngIf="!verificarDataInicioVigenciaValAtoInconcluso()"
            class="row mensagem-agendamento-nao-habilitado">Não é permitido alterar para esta data o agendamento pois o ato é inconcluso.</div>

        <div class="row">
            <div class="col-sm-12">
                <div class="form-group" style="float:right">
                    <button type="button" class="btn btn-primary" title="Anotar"
                        [disabled]="!verificarDataInicioVigenciaVal() || !verificarDataInicioVigenciaValAtoInconcluso()"
                        (click)="clickConfirmarDataInicioVigencia()">
                        Confirmar
                    </button>
                    <button type="button" class="btn btn-default" title="Cancelar"
                            (click)="clickCancelarDataInicioVigencia()">
                        Cancelar
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row irtopo nao-imprimivel" *ngIf="exibirBotaoIrTopo">
    <div class="col-md-11"></div>
    <div class="col-md-1">
        <a (click)="rolarParaInicio()" title="Ir para o topo da página">
            <i class="material-icons frame icon-36">keyboard_arrow_up</i>
        </a>
    </div>
</div>
